export default __webpack_public_path__ + "static/Niva Chevrolet-9825c052bacc60e2af81ac29ecbbc87e.png";